

const LogoIcon = () => {
  return (
    <div style={{ width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <img
        src="/oneadvanced-icon.svg"
        alt="OneAdvanced"
        style={{ width: 32, height: 32, display: 'block' }}
      />
    </div>
  );
};

export default LogoIcon;
